import image1 from "../../../Assets/project_images/Photo.jpg";
import image2 from "../../../Assets/project_images/Photo (1).jpg";
import image3 from "../../../Assets/project_images/Photo (2).jpg";
import image4 from "../../../Assets/project_images/Photo (3).jpg";
const Datasources = {
  projects: [
    {
      project_id: 1,
      project_name: "Modern Kitchan",
      project_category: "Decor / Artchitecture",
      project_thumb: image1,
    },
    {
      project_id: 2,
      project_name: "Modern Kitchan",
      project_category: "Decor / Artchitecture",
      project_thumb: image2,
    },
    {
      project_id: 3,
      project_name: "Modern Kitchan",
      project_category: "Decor / Artchitecture",
      project_thumb: image3,
    },
    {
      project_id: 4,
      project_name: "Modern Kitchan",
      project_category: "Decor / Artchitecture",
      project_thumb: image4,
    },
  ],
  counters: [
    {
      number: 12,
      description: "Year of Experience",
    },
    {
      number: 85,
      description: "Success Project",
    },
    {
      number: 15,
      description: "Active Project",
    },
    {
      number: 95,
      description: "Happy Customer",
    },
  ],
};

export default Datasources;
